export const replaceInArray = (currentArray, newObject) => {
  const updatedArray = [];
  currentArray.forEach((item) => {
    if (item.id === newObject.id) {
      return updatedArray.push({...newObject});
    }
    return updatedArray.push(item);
  });
  return updatedArray;
};

export const mergeInArray = (currentArray, newObject) => {
  const updatedArray = [];
  currentArray.forEach((item) => {
    if (item.id === newObject.id) {
      return updatedArray.push({...item, ...newObject});
    }
    return updatedArray.push(item);
  });
  return updatedArray;
};

export const altFind = (arr, callback) => {
  for (let i = 0; i < arr.length; i++) {
    const match = callback(arr[i]);
    if (match) {
      return arr[i];
    }
  }
  return null;
};

export const intersect = (arrA, arrB) => {
  const setA = new Set(arrA);
  const setB = new Set(arrB);
  const intersection = new Set([...setA].filter((item) => setB.has(item)));
  return Array.from(intersection);
};

export const mergeArrays = (arrA, arrB) => {
  const setA = new Set(arrA);
  const setB = new Set(arrB);
  const merge = new Set(function *() { yield* setA; yield* setB; }());
  return Array.from(merge);
};
